<script>
  import Day from './Day.svelte';

  import { DateTime } from 'luxon';
  import fetchNode from '../../../helpers/FetchNode.js';
	import deepcopy from 'deepcopy';
  import standardizeDate from '../../../helpers/standardizeDate.js';

  export let property;
  export let dateRange;
  export let grid;
  export let user;
  export let blocks;
  export let currency;
  export let height;
  export let markupPercentage;

  let propertyServices = [], RUPricing = [];

  if (user.accountRole.toLowerCase() === 'cleaner') {
    const propertyServicesReqOptions = {
      airbetterId: property.id,
      dateFrom: standardizeDate(dateRange.start),
      dateTo: standardizeDate(dateRange.end)
    };

    fetchNode('propertyServices', propertyServicesReqOptions)
      .then(res => propertyServices = res);
  }

  const RUPricingReqOptions = {
    propertyId: property.propertyId,
    dateFrom: standardizeDate(dateRange.start),
    dateTo: standardizeDate(dateRange.end)
  }
    
  fetchNode('dailyPricing', RUPricingReqOptions)
    .then(res => RUPricing = res.response);

  $: _grid = addCleaningToGrid(propertyServices, grid);
	$: _grid = addPricingToGrid(RUPricing, _grid);

  const addCleaningToGrid = (services, grid) => {
    const gridStart = grid[0].date.setZone('utc', { keepLocalTime: false });
    const gridEnd   = grid[grid.length - 1].date.setZone('utc', { keepLocalTime: false });
    let _grid = deepcopy(grid);

    const typesDefinition = {
      '1': 'checkout',
      '2': 'midstay',
      '3': 'touchup',
      '4': 'deepclean'
    };

    services.forEach(service => {
      if (service) {
        if (service.subtypeId.id == '1' || service.subtypeId.id == '2' || service.subtypeId.id == '3' || service.subtypeId.id == '4') {
          const scheduledAt = DateTime.fromISO(service.dateScheduled).setZone('utc', { keepLocalTime: false });

          if (gridStart <= scheduledAt && scheduledAt <= gridEnd) {
            const offset = Math.floor(scheduledAt.diff(gridStart, 'days').toObject().days);

            _grid[offset][typesDefinition[service.subtypeId.id]] = service;
          }
        }
      }
    });

    return _grid;
  };

  const addPricingToGrid = (pricing, grid) => {
    return grid.map(day => {
      day.price = getPrice(day.date, pricing);

      if (day.price) {
				if (property.markupPercentage) {
					day.price.public_price = Math.ceil(day.price.price * (1 + (property.markupPercentage / 100)));
				} else {
					day.price.public_price = Math.ceil(day.price.price * (1 + (markupPercentage / 100 )));
				}
			}

      return day;
    });
  };

  const getPrice = (date, pricing) => {
    const _date = standardizeDate(new Date(date.ts));

    return pricing.find(day => day.day === _date);
  };
</script>

{#each _grid as day, i}
  <Day day={day} blocks={blocks} user={user} currency={currency} height={height} />
{/each}